import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=ebbb4492&scoped=true"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=ebbb4492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbb4492",
  null
  
)

export default component.exports